import React from 'react';
import { Slot } from 'react-page-layout';
import PropTypes from 'prop-types';

export default function Blank({ content }) {
    return (
        <div className="modal--inner">
            <div className="modal--scroller">
                <Slot name="content">
                    { content }
                </Slot>
            </div>
        </div>
    );
}

Blank.propTypes = {
    content: PropTypes.any,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/modal/blank/index.js